module.exports = __webpack_public_path__ + "img/tooltip-hand-like.ced46385.png";